module.exports = __webpack_public_path__ + "static/media/what-are-you-thinking.0af9cd29.txt";